"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = _interopRequireDefault(require("./Core"));
var _Locale = _interopRequireDefault(require("./Locale"));
require("./styles.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Quiz = function Quiz(_ref) {
  var quiz = _ref.quiz,
    shuffle = _ref.shuffle,
    shuffleAnswer = _ref.shuffleAnswer,
    showDefaultResult = _ref.showDefaultResult,
    onComplete = _ref.onComplete,
    customResultPage = _ref.customResultPage,
    showInstantFeedback = _ref.showInstantFeedback,
    continueTillCorrect = _ref.continueTillCorrect,
    revealAnswerOnSubmit = _ref.revealAnswerOnSubmit,
    allowNavigation = _ref.allowNavigation,
    onQuestionSubmit = _ref.onQuestionSubmit,
    disableSynopsis = _ref.disableSynopsis;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    start = _useState2[0],
    setStart = _useState2[1];
  var _useState3 = (0, _react.useState)(quiz.questions),
    _useState4 = _slicedToArray(_useState3, 2),
    questions = _useState4[0],
    setQuestions = _useState4[1];
  var nrOfQuestions = quiz.nrOfQuestions && quiz.nrOfQuestions < quiz.questions.length ? quiz.nrOfQuestions : quiz.questions.length;

  // Shuffle answers funtion here
  var shuffleAnswerSequence = function shuffleAnswerSequence() {
    var oldQuestions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var newQuestions = oldQuestions.map(function (question) {
      var _question$answers;
      var answerWithIndex = (_question$answers = question.answers) === null || _question$answers === void 0 ? void 0 : _question$answers.map(function (ans, i) {
        return [ans, i];
      });
      var shuffledAnswersWithIndex = answerWithIndex.sort(function () {
        return Math.random() - 0.5;
      });
      var shuffledAnswers = shuffledAnswersWithIndex.map(function (ans) {
        return ans[0];
      });
      if (question.answerSelectionType === 'single') {
        var oldCorrectAnswer = question.correctAnswer;
        var newCorrectAnswer = shuffledAnswersWithIndex.findIndex(function (ans) {
          return "".concat(ans[1] + 1) === "".concat(oldCorrectAnswer);
        }) + 1;
        return _objectSpread(_objectSpread({}, question), {}, {
          correctAnswer: "".concat(newCorrectAnswer),
          answers: shuffledAnswers
        });
      }
      if (question.answerSelectionType === 'multiple') {
        var _oldCorrectAnswer = question.correctAnswer;
        var _newCorrectAnswer = _oldCorrectAnswer.map(function (cans) {
          return shuffledAnswersWithIndex.findIndex(function (ans) {
            return "".concat(ans[1] + 1) === "".concat(cans);
          }) + 1;
        });
        return _objectSpread(_objectSpread({}, question), {}, {
          correctAnswer: _newCorrectAnswer,
          answers: shuffledAnswers
        });
      }
      return question;
    });
    return newQuestions;
  };
  var shuffleQuestions = (0, _react.useCallback)(function (q) {
    for (var i = q.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var _ref2 = [q[j], q[i]];
      q[i] = _ref2[0];
      q[j] = _ref2[1];
    }
    return q;
  }, []);
  (0, _react.useEffect)(function () {
    if (disableSynopsis) setStart(true);
  }, []);
  (0, _react.useEffect)(function () {
    var newQuestions = quiz.questions;
    if (shuffle) {
      newQuestions = shuffleQuestions(newQuestions);
    }
    if (shuffleAnswer) {
      newQuestions = shuffleAnswerSequence(newQuestions);
    }
    newQuestions.length = nrOfQuestions;
    newQuestions = newQuestions.map(function (question, index) {
      return _objectSpread(_objectSpread({}, question), {}, {
        questionIndex: index + 1
      });
    });
    setQuestions(newQuestions);
  }, [start]);
  var validateQuiz = function validateQuiz(q) {
    if (!q) {
      console.error('Quiz object is required.');
      return false;
    }
    for (var i = 0; i < questions.length; i += 1) {
      var _questions$i = questions[i],
        question = _questions$i.question,
        questionType = _questions$i.questionType,
        answerSelectionType = _questions$i.answerSelectionType,
        answers = _questions$i.answers,
        correctAnswer = _questions$i.correctAnswer;
      if (!question) {
        console.error("Field 'question' is required.");
        return false;
      }
      if (!questionType) {
        console.error("Field 'questionType' is required.");
        return false;
      }
      if (questionType !== 'text' && questionType !== 'photo') {
        console.error("The value of 'questionType' is either 'text' or 'photo'.");
        return false;
      }
      if (!answers) {
        console.error("Field 'answers' is required.");
        return false;
      }
      if (!Array.isArray(answers)) {
        console.error("Field 'answers' has to be an Array");
        return false;
      }
      if (!correctAnswer) {
        console.error("Field 'correctAnswer' is required.");
        return false;
      }
      var selectType = answerSelectionType;
      if (!answerSelectionType) {
        // Default single to avoid code breaking due to automatic version upgrade
        console.warn('Field answerSelectionType should be defined since v0.3.0. Use single by default.');
        selectType = answerSelectionType || 'single';
      }
      if (selectType === 'single' && !(typeof selectType === 'string' || selectType instanceof String)) {
        console.error('answerSelectionType is single but expecting String in the field correctAnswer');
        return false;
      }
      if (selectType === 'multiple' && !Array.isArray(correctAnswer)) {
        console.error('answerSelectionType is multiple but expecting Array in the field correctAnswer');
        return false;
      }
    }
    return true;
  };
  if (!validateQuiz(quiz)) {
    return null;
  }
  var appLocale = _objectSpread(_objectSpread({}, _Locale["default"]), quiz.appLocale);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "react-quiz-container"
  }, !start && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, quiz.quizTitle), /*#__PURE__*/_react["default"].createElement("div", null, appLocale.landingHeaderText.replace('<questionLength>', nrOfQuestions)), quiz.quizSynopsis && /*#__PURE__*/_react["default"].createElement("div", {
    className: "quiz-synopsis"
  }, quiz.quizSynopsis), /*#__PURE__*/_react["default"].createElement("div", {
    className: "startQuizWrapper"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setStart(true);
    },
    className: "startQuizBtn btn"
  }, appLocale.startQuizBtn))), start && /*#__PURE__*/_react["default"].createElement(_Core["default"], {
    questions: questions,
    showDefaultResult: showDefaultResult,
    onComplete: onComplete,
    customResultPage: customResultPage,
    showInstantFeedback: showInstantFeedback,
    continueTillCorrect: continueTillCorrect,
    revealAnswerOnSubmit: revealAnswerOnSubmit,
    allowNavigation: allowNavigation,
    appLocale: appLocale,
    onQuestionSubmit: onQuestionSubmit
  }));
};
var _default = exports["default"] = Quiz;